import { AppointmentFormSchemaType } from "./createAppointment.reducer";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { IPetDataInputForm } from "../../services/create-appointment-v2/create-appointment-v2.interface";

export const actionTypes = {
  SET_PETS_SELECTED: "SET_PETS_SELECTED",
  SET_FIND_AVAILABILITY_FORM: "SET_FIND_AVAILABILITY_FORM",
  SET_REASON_FOR_VISIT: "SET_REASON_FOR_VISIT",
  SET_PROMO_CODE: "SET_PROMO_CODE",
  SET_CURRENT_STEP: "SET_CURRENT_STEP",
};

const setSelectedPets = (payload: IPetItemResponse[]) => ({
  type: actionTypes.SET_PETS_SELECTED,
  payload,
});


const setAppointmentsForm = (payload: AppointmentFormSchemaType | null) => ({
  type: actionTypes.SET_FIND_AVAILABILITY_FORM,
  payload,
});


const setReasonForVisit = (payload: { [key: string]: IPetDataInputForm }) => ({
  type: actionTypes.SET_REASON_FOR_VISIT,
  payload,
});

const setPromoCode = (payload: string[]) => ({
  type: actionTypes.SET_PROMO_CODE,
  payload,
});

const setCurrentStep = (payload: number) => ({
  type: actionTypes.SET_CURRENT_STEP,
  payload,
});

export default {
  setAppointmentsForm,
  setSelectedPets,
  setReasonForVisit,
  setPromoCode,
  setCurrentStep,
};
